var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useGetCustomerApi } from './api/customer/useGetCustomer.api';
import { useGetPersonApi } from './api/user/useGetPerson.api';
import { useGetFastMealScheduleApi } from './api/family/useGetFastMealSchedule.api';
import { useUpdateFastMealScheduleApi } from './api/family/useUpdateFastMealSchedule.api';
import { LoaderType } from './api/utils';
import { DailyPlanRecipeType } from '../models';
import { useLanguage } from '../locale';
import { isEqual } from 'lodash';
// Helper to check if a schedule map contains ALL days for ALL meals
var checkIsAllDaysSelected = function (schedule) {
    var allMeals = [
        DailyPlanRecipeType.BREAKFAST,
        DailyPlanRecipeType.MORNING_SNACK,
        DailyPlanRecipeType.LUNCH,
        DailyPlanRecipeType.SNACK,
        DailyPlanRecipeType.DINNER,
    ];
    var allDays = [0, 1, 2, 3, 4, 5, 6];
    return allMeals.every(function (meal) {
        var days = schedule[meal] || [];
        return days.length === 7 && allDays.every(function (d) { return days.includes(d); });
    });
};
// Helper to generate a full schedule
var generateFullSchedule = function () {
    var _a;
    var allDays = [0, 1, 2, 3, 4, 5, 6];
    return _a = {},
        _a[DailyPlanRecipeType.BREAKFAST] = __spreadArray([], allDays, true),
        _a[DailyPlanRecipeType.MORNING_SNACK] = __spreadArray([], allDays, true),
        _a[DailyPlanRecipeType.LUNCH] = __spreadArray([], allDays, true),
        _a[DailyPlanRecipeType.SNACK] = __spreadArray([], allDays, true),
        _a[DailyPlanRecipeType.DINNER] = __spreadArray([], allDays, true),
        _a;
};
// Helper: normalize schedule for comparison (sort arrays, handle undefined vs empty)
var normalizeSchedule = function (schedule) {
    var allMeals = [
        DailyPlanRecipeType.BREAKFAST,
        DailyPlanRecipeType.MORNING_SNACK,
        DailyPlanRecipeType.LUNCH,
        DailyPlanRecipeType.SNACK,
        DailyPlanRecipeType.DINNER,
    ];
    var normalized = {};
    // If schedule is null/undefined, treat it as an empty object (no days selected)
    var safeSchedule = schedule || {};
    allMeals.forEach(function (meal) {
        // Ensure array exists and is sorted [0,1,2] to compare correctly
        var days = safeSchedule[meal] || [];
        normalized[meal] = __spreadArray([], days, true).sort(function (a, b) { return a - b; });
    });
    return normalized;
};
export var useFastMealSettingsHook = function () {
    var t = useLanguage()[0];
    // 1. Fetch context data (user -> person -> familyId)
    var customer = useGetCustomerApi(true).data;
    var person = useGetPersonApi(customer === null || customer === void 0 ? void 0 : customer.personId).data;
    var familyId = person === null || person === void 0 ? void 0 : person.familyId;
    // 2. Fetch existing schedule
    var _a = useGetFastMealScheduleApi(familyId), apiData = _a.data, isLoading = _a.isLoading;
    // 3. Mutation for saving
    var _b = useUpdateFastMealScheduleApi(LoaderType.FullPage), updateSchedule = _b.mutateAsync, isSaving = _b.isLoading;
    // 4. Local state
    // 'localSchedule' holds the specific user selection.
    var _c = useState({}), localSchedule = _c[0], setLocalSchedule = _c[1];
    var _d = useState(false), isGlobalEnabled = _d[0], setIsGlobalEnabled = _d[1]; // "Tutti" btn
    // 5. Initialize state
    // Ref to track if we have initialized the data from server
    var isInitialized = useRef(false);
    // Ref to track the initial state of isGlobalEnabled for comparison
    var initialIsGlobalEnabled = useRef(false);
    useEffect(function () {
        // Run initialization only once when data becomes available
        if (apiData && !isInitialized.current) {
            var scheduleFromApi = apiData.schedule || {};
            var isAllSelected = checkIsAllDaysSelected(scheduleFromApi);
            setIsGlobalEnabled(isAllSelected);
            // Store initial state for comparison in hasChanges
            initialIsGlobalEnabled.current = isAllSelected;
            setLocalSchedule(scheduleFromApi);
            isInitialized.current = true;
        }
    }, [apiData]);
    // 6. Handlers
    var onToggleGlobal = useCallback(function (value) {
        setIsGlobalEnabled(value);
        if (value) {
            // Case TRUE: User activates global toggle
            // Sync localSchedule to full schedule immediately
            setLocalSchedule(generateFullSchedule());
        }
        else {
            // Case FALSE: User deactivates global toggle
            // Sync localSchedule to server data (what's actually saved)
            // Guardrail: fallback to empty schedule if apiData is not available
            var scheduleFromServer = (apiData === null || apiData === void 0 ? void 0 : apiData.schedule) || {};
            setLocalSchedule(scheduleFromServer);
        }
    }, [apiData]);
    var onMealScheduleUpdate = useCallback(function (meal, selectedDays) {
        setLocalSchedule(function (prev) {
            var _a, _b, _c;
            var currentDays = prev[meal] || [];
            // Case 1: "Tutti" btn (Select all) was clicked
            if (selectedDays.length === 7) {
                // If we already have 7 days, it means we are toggling OFF "Select all" -> clear array
                if (currentDays.length === 7) {
                    return __assign(__assign({}, prev), (_a = {}, _a[meal] = [], _a));
                }
                // Otherwise, select all
                return __assign(__assign({}, prev), (_b = {}, _b[meal] = selectedDays, _b));
            }
            // Case 2: single day clicked
            var dayToToggle = selectedDays[0];
            var alreadySelected = currentDays.includes(dayToToggle);
            var newDays;
            if (alreadySelected) {
                newDays = currentDays.filter(function (d) { return d !== dayToToggle; });
            }
            else {
                newDays = __spreadArray(__spreadArray([], currentDays, true), [dayToToggle], false);
            }
            return __assign(__assign({}, prev), (_c = {}, _c[meal] = newDays, _c));
        });
    }, []);
    // Helper to check if a specific day is selected for the UI
    var isDaySelected = useCallback(function (meal, dayIndex) {
        return (localSchedule[meal] || []).includes(dayIndex);
    }, [localSchedule]);
    var onSave = useCallback(function (goBack) { return __awaiter(void 0, void 0, void 0, function () {
        var scheduleToSend, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!familyId)
                        return [2 /*return*/];
                    scheduleToSend = isGlobalEnabled
                        ? generateFullSchedule()
                        : localSchedule;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateSchedule({
                            familyId: familyId,
                            request: {
                                schedule: scheduleToSend,
                                recalculation: true, // TODO: in the future this could be a user option instead of being hardcoded
                            },
                        })];
                case 2:
                    _a.sent();
                    // Reset initialization flag to allow re-hydration from server after save
                    // This ensures that when new apiData arrives (via query invalidation),
                    // the useEffect will sync localSchedule with the fresh server state
                    isInitialized.current = false;
                    if (goBack)
                        goBack();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Failed to save fast meal schedule', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [familyId, isGlobalEnabled, localSchedule, updateSchedule]);
    // 7. Computed properties
    // Check if there are changes compared to server data to enable/disable save button
    var hasChanges = useMemo(function () {
        // If apiData is not loaded yet (undefined), we can't save.
        // However, if apiData is loaded but apiData.schedule is null, we SHOULD be able to save (---> creation scenario)
        if (apiData === undefined)
            return false;
        // Check if isGlobalEnabled state has changed from initial state
        var globalStateChanged = isGlobalEnabled !== initialIsGlobalEnabled.current;
        // Normalize both for accurate comparison
        // apiData.schedule might be null/undefined, normalizeSchedule handles that as {}
        var initial = normalizeSchedule(apiData.schedule);
        var current = normalizeSchedule(isGlobalEnabled ? generateFullSchedule() : localSchedule);
        var scheduleChanged = !isEqual(initial, current);
        // Return true if either the schedule changed OR the global toggle state changed
        return scheduleChanged || globalStateChanged;
    }, [apiData, isGlobalEnabled, localSchedule]);
    return {
        t: t,
        isLoading: isLoading,
        isSaving: isSaving,
        isGlobalEnabled: isGlobalEnabled,
        onToggleGlobal: onToggleGlobal,
        onMealScheduleUpdate: onMealScheduleUpdate,
        isDaySelected: isDaySelected,
        onSave: onSave,
        hasChanges: hasChanges,
    };
};
